import { differenceInDays } from 'date-fns'

export const relevantReportsAdapter = (reports, requestType) => {
  if (!reports) {
    return undefined
  }
  return maybeRedacted(reports) || reports
    .reduce((acc, item) => {
      // eslint-disable-next-line camelcase
      acc.push({
        name: item.title,
        date: item.published_date || item.created,
        id: item.report_id,
        url: item.report_id && `/reports/${item.report_id}`, // routes.report({ id: item.report_id })
        reportType: item.report_type || item.metadata?.report_type?.[0], // metadata.report_type will be removed by NAUT-2176
        license_info: item.license_info,
        audience: item.audience,
        isNew: differenceInDays(new Date(), new Date(item.published_date || item.created)) <= 30
      })
      return acc
    }, [])
    .sort((a, b) => {
      // Float certain reports to the top
      if (!isOverviewOrProfile(a, requestType) && isOverviewOrProfile(b, requestType)) {
        return 1
      } else if (isOverviewOrProfile(a, requestType) && !isOverviewOrProfile(b, requestType)) {
        return -1
      }
      // Sort the rest by date
      if (a.date && b.date) {
        const aDate = new Date(a.date).toISOString()
        const bDate = new Date(b.date).toISOString()
        if (aDate < bDate) { return 1 }
        if (aDate > bDate) { return -1 }
      }
      return 0
    })
}

export const maybeRedacted = (value) => {
  return value === 'redacted' ? value : null
}

export const isOverviewOrProfile = (item, requestType) => {
  const { reportType } = item
  if (!reportType) return false
  return reportType && (reportType.includes(`${requestType} Overview`) || reportType.includes(`${requestType} Profile`))
}
